import { useEffect } from 'react';

import { getFeatureFlagsOverridesFromSessionStorage } from '../utils/getFeatureFlagsOverrides';
import { useResetFeatureFlagsStore } from './useResetFeatureFlagsStore';

/**
 * Load feature flags to useFeatureFlagsStore.
 * Note: it should only be called once at the app root because it initializes the store.
 */
export function useInitializeFeatureFlagsStore() {
  const initialize = useResetFeatureFlagsStore();

  useEffect(() => {
    const persistedFeatureFlags = getFeatureFlagsOverridesFromSessionStorage();

    initialize(persistedFeatureFlags);
  }, [initialize]);
}
